import { Item as BasketItem } from '../../weborder/BasketControl';
import { MenuItem } from '../api/menu/menu.types';

// #region selector types
export type BasketItemType = {
  index: number;
  item: MenuItem;
  options: any;
  quantity: number;
};
// #endregion

// #region hook types
export enum Source {
  // TODO - ORD-1259 check with Simon if "Checkout" can be switched to "Checkout Basket"
  CheckoutBasket = 'Checkout Basket',
  // TODO - ORD-1259 check with Simon if "Cross-sell added" can be switched to "Checkout Cross-sell"
  CheckoutCrossSell = 'Checkout Cross-sell',
  // TODO - ORD-1259 check with Simon if 'Basket' can be switched to 'Menu Basket' for remove events
  MenuBasket = 'Menu Basket',
  // TODO - ORD-1259 check with Simon if 'Options' can be switched to 'Menu Cards'
  // TODO - ORD-1259 check with Simon if 'Menu Area' can be switched to 'Menu Cards'
  MenuCards = 'Menu Cards',
  MenuCrossSellDialog = 'Menu Cross-sell Dialog',
  // TODO - ORD-1259 check with Simon if 'Search' can be switched to 'Menu Search'
  MenuSearch = 'Menu Search',
}

export interface AddItemHookPayload {
  item: MenuItem;
  source: Source;
}

export type RemoveItemHookPayload = AddItemHookPayload;
// #endregion

// #region action types
export type AddItemPayloadType = BasketItem;

export interface RemoveItemPayloadType {
  index: number;
  indexName: string;
  menuId: number;
}

export interface BasketActionsType extends QuantityControlType {
  onCheckout: (any) => void;
}

export interface QuantityControlType {
  onAddItem: (payload: AddItemPayloadType) => void;
  onRemoveItem: (payload: RemoveItemPayloadType) => void;
}
// #endregion
